import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";

const Categories = () => {
    const { sidebar, setSidebar, Dark, setDark, userData } = useContext(AppContext);
    return (
        <>
            <div
                className={sidebar ? "taskMain " : "cx-active taskMain"}
                id="cx-main"
            >
                <div className="employee_wallet_sales">
                    <div className="sub-header-role mb-4">
                        <h6 className="mt-2">Categories</h6>
                        <div className="btnFlex">
                            <button className="CategoryVie">Category Tree View</button>
                            <button className="CategoryCre">
                                <Link to="/CreateCategories">
                                    Create Category
                                </Link>
                            </button>
                        </div>
                    </div>
                    <div className="mainTableBox">
                        <div className="insideTable">
                            <table className="table table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>Parent Category</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <input type="text" className="form-control" />
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" />
                                        </td>
                                        <td>
                                            <input type="text" className="form-control" />
                                        </td>
                                        <td className="text-end">
                                            <button className="Clearbtn">
                                                Clear
                                            </button>
                                        </td>
                                    </tr>
                                    <tr className="text-center">
                                        <td colSpan={5}>No Data Found</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Categories;
